/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { MasterZoneListItem } from '../../resources/master-zone-list-item.model';

@Injectable()
export class MasterZonesGridDefinition extends LayoutBasedGridDefinition {
  options = {
    getRowNodeId: (data: MasterZoneListItem) => data.id,
    getRowClass: ({ _, data }: any) => !data.active ? 'deleted-class' : '',
  };
}
